import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "comment-footer" }
const _hoisted_3 = { class: "checkbox-row" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "checkbox-row" }
const _hoisted_6 = ["disabled"]

import { useSettingsStore } from "@/stores/setting";
import { computed } from "vue";
import { VueFinalModal } from "vue-final-modal";
import VueSelect from "vue-select";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommentModal',
  props: ['modelValue', 'disabled'],
  emits: ['close', 'save', 'update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props;

const settingStore = useSettingsStore();

const value = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

function onRepseCheckChange()
{
  props.modelValue.isBT = props.modelValue.isRepse 
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "comment-modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    "content-transition": "vfm-fade"
  }, {
    default: _withCtx(() => [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "tittle" }, [
        _createElementVNode("span", null, "Comment")
      ], -1)),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value.value.commentBox.text) = $event)),
          disabled: __props.disabled
        }, null, 8, _hoisted_1), [
          [_vModelText, value.value.commentBox.text]
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(VueSelect), {
          appendToBody: true,
          label: "name",
          options: _unref(settingStore).getCountries,
          clearable: false,
          disabled: __props.disabled,
          modelValue: value.value.commentBox.countryId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value.value.commentBox.countryId) = $event)),
          reduce: (item) => item.id
        }, null, 8, ["options", "disabled", "modelValue", "reduce"]),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            id: "r_repse",
            type: "checkbox",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value.value.isRepse) = $event)),
            disabled: __props.disabled,
            onChange: onRepseCheckChange
          }, null, 40, _hoisted_4), [
            [_vModelCheckbox, value.value.isRepse]
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "r_repse" }, "Site Work [REPSE]", -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            id: "r_business_trip",
            type: "checkbox",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((value.value.isBT) = $event)),
            disabled: value.value.isRepse || __props.disabled
          }, null, 8, _hoisted_6), [
            [_vModelCheckbox, value.value.isBT]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("label", { for: "r_business_trip" }, "Business Trip", -1))
        ]),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('close')))
        }, "Close")
      ])
    ]),
    _: 1
  }))
}
}

})